// extracted by mini-css-extract-plugin
export var layoutContainer = "_d3-0";
export var layoutContainerNoRounding = "_d3-6";
export var layoutContainerOpen = "_d3-5";
export var layoutContainerResizing = "_d3-1";
export var mainContent = "_d3-2";
export var resizeDivider = "_d3-3";
export var slidePanel = "_d3-4";